import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PagesModule } from '../pages/pages.module';
import { CardFieldsReqestedDocumentComponent } from './card-fields-requested-document/card-fields-requested-document';
import { BuildingBlockModule } from '../building-block/building-block.module';
import { PageSharedModule } from '@workflow/dynamic-render/page/shared/page-shared.module';
import { DynamicRenderSharedModule } from '@workflow/dynamic-render/shared/shared.module';
import { DynamicPipeModule } from '@workflow/pipe/dynamic-pipe.module';

const components = [CardFieldsReqestedDocumentComponent];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, DynamicPipeModule, DynamicRenderSharedModule, PageSharedModule, PagesModule, BuildingBlockModule]
})
export class CustomCardsModule {}
